export default __webpack_public_path__ + "static/media/fitnesslogo1.7f217060.png";